import { useState, useContext } from 'react';
import '../../FinancialBuilder/CompaniesPage/CompaniesPage.css'

import { PSSBPageContext } from '../PSBBPage.jsx';
import { industryDetails } from '../../constants.jsx';
import { genericPOSTDatabaseCall } from '../../helperFunctions.jsx';
import { ProductDetails } from '../../FinancialBuilder/ProductsPage/ProductsPage.jsx'


async function addProductToDatabase(product) {
    return genericPOSTDatabaseCall('/api/fb/addProduct', { product }, 'product');
}

function ProductsPage({showNavigationControls = true}) {
    const { setPageNum, entitySelected, setEntitySelected, messageApi, useInvestorReadyFinancial } = useContext(PSSBPageContext);
    const [newProductName, setNewProductName] = useState("");

    const addNewProduct = async () => {
        if (!newProductName) {
            messageApi.error('Please enter a product name');
            return;
        }
        messageApi.loading('Adding product...', 0);
        try {
            //console.log('Adding product for company id:', entitySelected.fb_id);
            const newProduct = await addProductToDatabase({
                name: newProductName,
                company_id: entitySelected.fb_id,
                growth_rate: industryDetails[entitySelected.industry]['default_growth_rate'],
                growth_adjustment: industryDetails[entitySelected.industry]['default_growth_adjustment']
            });
            setEntitySelected(prev => ({
                ...prev,
                products: [...prev.products, newProduct]
            }));
            setNewProductName(''); // Clear input field
            messageApi.destroy();
            messageApi.success('Product added successfully');
        } catch (error) {
            console.error('Error adding product:', error);
            messageApi.destroy();
            messageApi.error('Failed to add product');
        }
    }

    return (
        <div className="financial-builder-container entity-industry-container">
            <h2>{entitySelected.name}- Products ({entitySelected.products.length})</h2>
            <div className="product-list">
                <h3>Existing Products</h3>
                <div>
                    {entitySelected.products.map(product => (
                        <ProductDetails useInvestorReadyFinancial={useInvestorReadyFinancial} modalView={!showNavigationControls} key={product.id} product={product} setCompanySelected={setEntitySelected} messageApi={messageApi} companySelected={entitySelected} />
                    ))}
                </div>
            </div>
            <div className="add-entity-controls form-section">
                <div className="form-row">
                    <label htmlFor="new_product_name">Add New Product</label>
                    <input type="text" className="form-input" value={newProductName} onChange={(e) => setNewProductName(e.target.value)} placeholder="Enter product name" id="new_product_name" />
                </div>
                <button className="add-button" onClick={addNewProduct}>ADD Product</button>
            </div>
            {!showNavigationControls ? <></>: (
            <div className="navigation-button-container">
                <button type="button" onClick={() => setPageNum(1)} className="next-button">Back</button>
                <button type="button" disabled={entitySelected.products.length < 1} onClick={() => setPageNum(3)} className="next-button">Next</button>
            </div>
            )}
        </div>
    );
}

export default ProductsPage;